const styles = theme => ({
  slider: {
    position: "relative",

    "& .alice-carousel__stage-item img": {
      height: "calc(100vh - 140px)",
      width: "100%",
      objectFit: 'cover'
    },

    "& .alice-carousel__dots": {
      position: "absolute",
      bottom: 10,
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 10
    },

    [theme.breakpoints.down('md')]: {
      "& .alice-carousel__stage-item img": {
        height: "calc(100vh/2)"
      }
    },

    [theme.breakpoints.down('sm')]: {
      "& .alice-carousel__stage-item img": {
        height: "calc(100vh/3 - 20px)"
      }
    }
  }
});

export default styles;
